import {
    createContext,
    useState,
    useEffect,
    useMemo,
    useContext,
    useCallback,
    useRef,
} from 'react';

import { useGeneral } from '../../Context/GeneralContext';

if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
    window.process = { env: {} };
}

if (typeof window !== 'undefined' && typeof process === 'undefined') {
    window.process = { env: {} };
}

const HomeContext = createContext();

export function HomeProvider(props) {
    const tokenSessionObject = JSON.parse(sessionStorage.getItem('token'));
    const { logout } = useGeneral();
    const [prueba, setPrueba] = useState('false');
    const [selectedF, setSelectedF] = useState(new Date());
    const [selectedL, setSelectedL] = useState(3);
    const [lines, setLines] = useState([]);
    const [areas, setAreas] = useState([]);
    const [linesByArea, setLinesByArea] = useState([]);
    const [celdas, setCeldas] = useState([]);
    const [selectedArea, setSelectedAreaState] = useState(null);
    const [selectedLinea, setSelectedLineaState] = useState(null);
    const [selectedCelda, setSelectedCeldaState] = useState(null);
    const [fechaWIni, setFechaWIni] = useState(new Date('11-07-2022'));
    const [fechaWFin, setFechaWFin] = useState(new Date('11-15-2022'));
    const [orders, setOrders] = useState([]);
    const [corridasR, setCorridasR] = useState([]);
    const [porU, setPorU] = useState(0);
    const [porE, setPorE] = useState(0);
    const [mtbf, setMtbf] = useState(0);
    const [mttr, setMttr] = useState(0);
    const [estatusLinea, setEstatusLinea] = useState('');
    const [nSeries, setNSeries] = useState([]);
    const [nSeries1] = useState([]);
    const [seriesByLine, setSeriesByLine] = useState({});
    const [statusByLine, setStatusByLine] = useState({});
    const linesRef = useRef([]);
    const loadStatusesAbortRef = useRef(null);
    const loadAllSeriesAbortRef = useRef(null);

    useEffect(() => {
        linesRef.current = lines;
    }, [lines]);

    // Gantt: solo responde al selector de Línea (ignora Celda)
    const lineSelect = useMemo(() => {
        if (selectedLinea) return selectedLinea.id;
        return 0;
    }, [selectedLinea]);

    // KPI: baja hasta Celda si está seleccionada, sino usa Línea
    const kpiCeldaId = useMemo(() => {
        return selectedCelda?.id ?? selectedLinea?.id ?? null;
    }, [selectedCelda, selectedLinea]);

    // Líneas a mostrar en los Gantts y en el selector (de la API cuando hay área, todas si no)
    const filteredLines = useMemo(() => {
        if (!selectedArea) return lines;
        return linesByArea;
    }, [lines, selectedArea, linesByArea]);

    const getOEETEEP = useCallback(
        async (fIni, fFin) => {
            if (process.env.REACT_APP_ALLOW_HOME_KPI_GRAPH !== 'true') {
                return;
            }
            if (!selectedArea) return;

            const offsetMinutos = -new Date().getTimezoneOffset();

            // Fecha ini: medianoche del día seleccionado (00:00:00)
            const dIni = new Date(selectedF);
            dIni.setHours(0, 0, 0, 0);

            // Fecha fin: medianoche del día siguiente (00:00:00)
            const dFin = new Date(selectedF);
            dFin.setDate(dFin.getDate() + 1);
            dFin.setHours(0, 0, 0, 0);

            const fechaini = dIni.toISOString();
            const fechafin = dFin.toISOString();

            const params = new URLSearchParams({ offsetMinutos, ini: fechaini, fin: fechafin });
            params.append('area', selectedArea.area1);
            if (selectedLinea) params.append('linea', selectedLinea.id);
            if (selectedCelda) params.append('celda', selectedCelda.id);

            const data = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT}/Informes/GetOEETEEP?${params.toString()}`,
                {
                    method: 'GET',
                    headers: {
                        authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (Math.floor(data.status / 100) === 2) {
                const values = await data.json();
                const item = Array.isArray(values) ? values[0] : values;
                if (item) {
                    setPorU(Number.isFinite(item.teep) ? item.teep : 0);
                    setPorE(Number.isFinite(item.oee) ? item.oee : 0);
                    setMtbf(Number.isFinite(item.mtbf) ? item.mtbf : 0);
                    setMttr(Number.isFinite(item.mttr) ? item.mttr : 0);
                }
            }
        },
        [tokenSessionObject.token, selectedArea, selectedLinea, selectedCelda, selectedF]
    );

    const handleUnauthorized = useCallback(
        (response) => {
            if (response?.status === 401) {
                logout();
                return true;
            }
            return false;
        },
        [logout]
    );

    const fetchCorridasForLine = useCallback(
        async (lineId, fIni, fFin) => {
            if (process.env.REACT_APP_ALLOW_HOME_GANTT_GRAPH !== 'true') {
                return [];
            }
            if (lineId === -1 || lineId === undefined || lineId === null) {
                return [];
            }
            const fechaini = `${fIni.toISOString().slice(0, 10)}T00:00:00.000Z`;
            const fechafin = `${fFin.toISOString().slice(0, 10)}T23:59:59.000Z`;

            const data = {
                fechaini: fechaini,
                fechafin: fechafin,
                linea: lineId,
            };

            const corri = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT}/Estadisticas/ReporteCorridas`,
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!corri.ok) {
                handleUnauthorized(corri);
                return [];
            }
            return await corri.json();
        },
        [tokenSessionObject.token, handleUnauthorized]
    );

    const resolveLineRequestId = useCallback((lineId) => {
        const line = linesRef.current.find((item) => item.id === lineId);
        if (!line) {
            return lineId;
        }
        return line.linea ?? line.celda ?? line.id ?? lineId;
    }, []);

    const fetchOrdersForLine = useCallback(
        async (lineId, fIni, fFin) => {
            if (process.env.REACT_APP_ALLOW_HOME_GANTT_GRAPH !== 'true') {
                return [];
            }
            if (lineId === -1 || lineId === undefined || lineId === null) {
                return [];
            }
            const fechaini = `${fIni.toISOString().slice(0, 10)}T00:00:00.000Z`;
            const fechafin = `${fFin.toISOString().slice(0, 10)}T23:59:59.000Z`;

            const data = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/ordenesFecha?linea=${lineId}&start=${fechaini}&end=${fechafin}`,
                {
                    method: 'GET',
                    headers: {
                        authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!data.ok) {
                handleUnauthorized(data);
                return [];
            }
            return await data.json();
        },
        [tokenSessionObject.token, handleUnauthorized]
    );

    const getOrders = useCallback(
        async (fIni, fFin) => {
            if (process.env.REACT_APP_ALLOW_HOME_GANTT_GRAPH !== 'true') {
                return;
            }
            if (lineSelect === -1 || lineSelect === 0) {
                return;
            }
            const requestLineId = resolveLineRequestId(lineSelect);
            const ordenes = await fetchOrdersForLine(requestLineId, fIni, fFin);
            setOrders(ordenes);

            const corridas = await fetchCorridasForLine(requestLineId, fIni, fFin);
            setCorridasR(corridas);

            getOEETEEP(fIni, fFin);
        },
        [fetchCorridasForLine, fetchOrdersForLine, getOEETEEP, lineSelect, resolveLineRequestId]
    );

    const sumarDias = useCallback((fecha, dias) => {
        fecha.setDate(fecha.getDate() + dias);
        return fecha;
    }, []);

    const getDateRange = useCallback(
        (baseDate) => {
            const fIni = sumarDias(new Date(baseDate), -1);
            const fFin = sumarDias(new Date(baseDate), 1);
            const finalDate = fFin.getTime() > baseDate.getTime() ? fFin : baseDate;
            return { fIni, fFin: finalDate };
        },
        [sumarDias]
    );

    const findWeek = useCallback(() => {
        const { fIni, fFin } = getDateRange(selectedF);

        setFechaWIni(fIni);
        setFechaWFin(fFin);
        if (lineSelect !== 0) {
            getOrders(fIni, fFin);
        }
        getOEETEEP(fIni, fFin);
    }, [getDateRange, getOEETEEP, getOrders, lineSelect, selectedF]);

    const getLines = useCallback(async () => {
        try {
            const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/lineas`, {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                },
            });
            if (!data.ok) return;
            const linesData = await data.json();
            setLines(linesData);
        } catch { /* ignore */ }
    }, [tokenSessionObject.token]);

    const getAreas = useCallback(async () => {
        try {
            const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/areas`, {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                },
            });
            if (data.ok) {
                setAreas(await data.json());
            }
        } catch { /* ignore */ }
    }, [tokenSessionObject.token]);

    const getCeldas = useCallback(
        async (lineaId) => {
            const url = `${process.env.REACT_APP_SERVICE_ENDPOINT}/CeldaPorLinea/CeldaPorLinea?linea=${lineaId}`;
            const data = await fetch(url, {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                },
            });
            if (data.ok) {
                const raw = await data.json();
                // Aplanar celdas de todas las líneas, excluir orden=0, normalizar a {id, nombre}
                const celdas = raw
                    .flatMap((l) => l.celdas || [])
                    .filter((c) => c.orden !== 0)
                    .map((c) => ({ id: c.celda, nombre: c.nombreCelda }));
                setCeldas(celdas);
            }
        },
        [tokenSessionObject.token]
    );

    // Setters con limpieza en cascada
    const setSelectedArea = useCallback(
        async (area) => {
            setSelectedAreaState(area);
            setSelectedLineaState(null);
            setSelectedCeldaState(null);
            setCeldas([]);
            setLinesByArea([]);
            if (!area) return;
            try {
                const data = await fetch(
                    `${process.env.REACT_APP_SERVICE_ENDPOINT}/lineas?area=${area.area1}`,
                    {
                        method: 'GET',
                        headers: {
                            authorization: `Bearer ${tokenSessionObject.token}`,
                            Accept: 'application/json',
                        },
                    }
                );
                if (data.ok) {
                    setLinesByArea(await data.json());
                }
            } catch (_) { }
        },
        [tokenSessionObject.token]
    );

    const setSelectedLinea = useCallback(
        (linea) => {
            setSelectedLineaState(linea);
            setSelectedCeldaState(null);
            if (linea) {
                getCeldas(linea.id);
            } else {
                setCeldas([]);
            }
        },
        [getCeldas]
    );

    const setSelectedCelda = useCallback((celda) => {
        setSelectedCeldaState(celda);
    }, []);

    const buildSeries = useCallback(
        (ordersList, corridasList) => {
            const toTime = (value) => {
                const time = new Date(value).getTime();
                return Number.isFinite(time) ? time : null;
            };
            const normalizeStart = (entity) =>
                toTime(entity.fechaIniReal ?? entity.fechaIni ?? entity.fechaInicio);
            const normalizeEnd = (entity) => {
                if (entity.fechaFinReal && toTime(entity.fechaFinReal) !== null) {
                    return toTime(entity.fechaFinReal);
                }
                if (entity.fechaFin && toTime(entity.fechaFin) !== null) {
                    return toTime(entity.fechaFin);
                }
                return Date.now();
            };

            const createPlan = (orden) => {
                const start = toTime(orden.fechaIni);
                const end = toTime(orden.fechaFin);
                if (start === null || end === null) {
                    return null;
                }
                return {
                    name: String(orden.corrida ?? orden.ordenProd ?? 'Plan'),
                    orden: orden.ordenProd,
                    data: [
                        {
                            x: 'Plan',
                            y: [start, end],
                            z: [orden.meta ?? 'NA', orden.nombreSku ?? orden.descripcion ?? ''],
                            fillColor: orden.tipo === 1 ? getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#903BFF' : '#FFC800',
                            strokeColor: orden.tipo === 1 ? getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#903BFF' : '#FFC800',
                        },
                    ],
                };
            };

            const createReal = (corrida) => {
                const start = normalizeStart(corrida);
                let end = normalizeEnd(corrida);
                if (start === null) {
                    return null;
                }
                if (end === null || end < start) {
                    end = start + 60_000;
                }
                return {
                    name: String(corrida.corrida ?? 'Real'),
                    orden: corrida.ordenProd,
                    corrida: corrida.corrida,
                    data: [
                        {
                            x: 'Real',
                            y: [start, end],
                            z: [corrida.producido ?? 0, corrida.nombre ?? ''],
                            fillColor: '#00B884',
                            strokeColor: '#00B884',
                        },
                    ],
                };
            };

            const planEntries = ordersList.map(createPlan).filter(Boolean);
            const realEntries = corridasList.map(createReal).filter(Boolean);
            const includePlan = selectedL === 3 || selectedL === 1;
            const includeReal = selectedL === 3 || selectedL === 2;
            return [
                ...(includePlan ? planEntries : []),
                ...(includeReal ? realEntries : []),
            ];
        },
        [selectedL]
    );

    const updateData = useCallback(() => {
        if (lineSelect === 0) {
            setNSeries([]);
            return;
        }
        setNSeries(buildSeries(orders, corridasR));
    }, [buildSeries, corridasR, lineSelect, orders]);

    const fetchStatusLinea = useCallback(
        async (lineId) => {
            if (!tokenSessionObject?.token) {
                return null;
            }
            if (lineId === -1 || lineId === undefined || lineId === null) {
                return null;
            }
            const data = {
                celda: lineId,
                cantHoras: 1,
            };

            try {
                const res = await fetch(
                    `${process.env.REACT_APP_SERVICE_ENDPOINT}/Paros/GetEstatusLinea`,
                    {
                        method: 'POST',
                        body: JSON.stringify(data),
                        headers: {
                            Authorization: `Bearer ${tokenSessionObject.token}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    }
                );

                if (!res.ok) {
                    return null;
                }

                const respuesta = await res.json();
                let nEstatus = 'grey';

                if (Array.isArray(respuesta.estatusLinea) && respuesta.estatusLinea.length > 0) {
                    for (const resp of respuesta.estatusLinea) {
                        if (resp.estatus === 0) {
                            nEstatus = 'grey';
                        } else if (resp.estatus === 1) {
                            nEstatus = 'green';
                        } else {
                            nEstatus = 'red';
                        }
                    }
                }

                return nEstatus;
            } catch (error) {
                return null;
            }
        },
        [tokenSessionObject?.token]
    );

    const getStatusLinea = useCallback(async () => {
        if (!tokenSessionObject?.token) {
            return;
        }
        if (lineSelect === -1 || lineSelect === 0 || lineSelect === undefined || lineSelect === null) {
            return;
        }
        const requestLineId = resolveLineRequestId(lineSelect);
        const status = await fetchStatusLinea(requestLineId);
        if (status) {
            setEstatusLinea(status);
        }
    }, [fetchStatusLinea, lineSelect, resolveLineRequestId, tokenSessionObject?.token]);

    useEffect(() => {
        getLines();
    }, [getLines]);

    useEffect(() => {
        getAreas();
    }, [getAreas]);

    // Auto-seleccionar la primera área cuando se carguen las áreas
    useEffect(() => {
        if (areas.length > 0) {
            setSelectedArea(areas[0]);
        }
    }, [areas, setSelectedArea]);

    useEffect(() => {
        getStatusLinea();
    }, [getStatusLinea]);

    // Pre-cargar estatus para las líneas visibles (modo múltiple)
    // Requiere selectedArea para evitar carga masiva al inicio
    useEffect(() => {
        if (lineSelect !== 0 || filteredLines.length === 0 || !selectedArea) {
            return;
        }
        loadStatusesAbortRef.current?.abort();
        const controller = new AbortController();
        loadStatusesAbortRef.current = controller;

        const loadStatuses = async () => {
            try {
                const entries = await Promise.all(
                    filteredLines.map(async (line) => {
                        if (controller.signal.aborted) return [line.id, 'grey'];
                        const requestLineId = resolveLineRequestId(line.id);
                        const status = await fetchStatusLinea(requestLineId);
                        return [line.id, status || 'grey'];
                    })
                );
                if (!controller.signal.aborted) {
                    setStatusByLine(Object.fromEntries(entries));
                }
            } catch (e) {
                if (e.name !== 'AbortError') { /* ignore */ }
            }
        };
        loadStatuses();
        return () => controller.abort();
    }, [fetchStatusLinea, lineSelect, filteredLines, resolveLineRequestId, selectedArea]);

    useEffect(() => {
        updateData();
    }, [orders, corridasR, updateData]);

    // Pre-cargar series para las líneas visibles (modo múltiple)
    // Requiere selectedArea para evitar carga masiva al inicio
    useEffect(() => {
        if (lineSelect !== 0 || filteredLines.length === 0 || !selectedArea) {
            return;
        }
        loadAllSeriesAbortRef.current?.abort();
        const controller = new AbortController();
        loadAllSeriesAbortRef.current = controller;

        const { fIni, fFin } = getDateRange(selectedF);
        const loadAllSeries = async () => {
            try {
                const entries = await Promise.all(
                    filteredLines.map(async (line) => {
                        if (controller.signal.aborted) return [line.id, []];
                        const requestLineId = resolveLineRequestId(line.id);
                        const [ordenes, corridas] = await Promise.all([
                            fetchOrdersForLine(requestLineId, fIni, fFin),
                            fetchCorridasForLine(requestLineId, fIni, fFin),
                        ]);
                        return [line.id, buildSeries(ordenes, corridas)];
                    })
                );
                if (!controller.signal.aborted) {
                    setSeriesByLine(Object.fromEntries(entries));
                }
            } catch (e) {
                if (e.name !== 'AbortError') { /* ignore */ }
            }
        };
        loadAllSeries();
        return () => controller.abort();
    }, [
        buildSeries,
        fetchCorridasForLine,
        fetchOrdersForLine,
        getDateRange,
        lineSelect,
        filteredLines,
        resolveLineRequestId,
        selectedF,
        selectedArea,
    ]);

    useEffect(() => {
        if (lineSelect !== 0) {
            setSeriesByLine({});
            setStatusByLine({});
        }
    }, [lineSelect]);

    useEffect(() => {
        if (lines.length > 0) {
            setOrders([]);
            setCorridasR([]);
            findWeek();
        }
    }, [findWeek, lineSelect, lines.length, selectedF]);

    useEffect(() => {
        if (lines.length > 0) {
            updateData();
        }
    }, [lines.length, selectedL, updateData]);

    const HomeValues = useMemo(() => {
        return {
            prueba,
            setPrueba,
            selectedF,
            setSelectedF,
            selectedL,
            setSelectedL,
            lines,
            lineSelect,
            kpiCeldaId,
            filteredLines,
            areas,
            celdas,
            selectedArea,
            setSelectedArea,
            selectedLinea,
            setSelectedLinea,
            selectedCelda,
            setSelectedCelda,
            fechaWIni,
            setFechaWIni,
            fechaWFin,
            setFechaWFin,
            orders,
            getOrders,
            findWeek,
            sumarDias,
            updateData,
            nSeries,
            seriesByLine,
            mtbf,
            setMtbf,
            mttr,
            setMttr,
            nSeries1,
            porU,
            porE,
            estatusLinea,
            statusByLine,
        };
    }, [
        prueba,
        selectedF,
        selectedL,
        lines,
        lineSelect,
        kpiCeldaId,
        filteredLines,
        areas,
        celdas,
        selectedArea,
        setSelectedArea,
        selectedLinea,
        setSelectedLinea,
        selectedCelda,
        setSelectedCelda,
        fechaWIni,
        fechaWFin,
        orders,
        getOrders,
        findWeek,
        sumarDias,
        updateData,
        nSeries,
        seriesByLine,
        mtbf,
        mttr,
        nSeries1,
        porU,
        porE,
        estatusLinea,
        statusByLine,
    ]);

    return <HomeContext.Provider value={HomeValues} {...props} />;
}

export function useHome() {
    const context = useContext(HomeContext);
    if (!context) {
        throw new Error('useOrdProd debe estar dentro del proveedor HomeContext');
    }
    return context;
}
